// extracted by mini-css-extract-plugin
export default {"program":"program_program__wwfaS","title":"program_title__viDU6","dayTitle":"program_dayTitle__1gAtF","dayActivities":"program_dayActivities__LSO6a","time":"program_time__hP-Pe"};